/* unplugin-vue-components disabled */import { render } from "./superuser.vue?vue&type=template&id=54d0fed5&scoped=true"
import script from "./superuser.vue?vue&type=script&setup=true&lang=js"
export * from "./superuser.vue?vue&type=script&setup=true&lang=js"

import "./superuser.vue?vue&type=style&index=0&id=54d0fed5&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d0fed5"],['__file',"src/pages/settings/superuser/superuser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54d0fed5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54d0fed5', __exports__)) {
    api.reload('54d0fed5', __exports__)
  }
  
  module.hot.accept("./superuser.vue?vue&type=template&id=54d0fed5&scoped=true", () => {
    api.rerender('54d0fed5', render)
  })

}


export default __exports__